// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1_muL","cls2":"SimplePaperPodcast-cls2_bEa SimplePaperPodcast-cls1_muL"};